{
  "title": "Dungeons",
  "lead": "Every biome of the pack and the workshop's own. A pack biome is its design file with the workshop's changes on top (admin builds apply them from their next floor); a user biome is a whole file (a base biome plus its own values). Floors come from the engine's own generator (delve-sim).",
  "list": {
    "label": "Biomes",
    "pack": "Pack biomes — {{pack}}",
    "user": "User biomes",
    "noPack": "This pack publishes no biome design files (designs.json).",
    "noUser": "None yet.",
    "test": "(test)",
    "changed": "Changed by the workshop (not integrated yet)",
    "unreadable": "{{id}} (unreadable)",
    "unsaved": "not saved yet",
    "new": "New",
    "newPack": "New pack biome…",
    "newUser": "New user biome…"
  },
  "pick": "Pick a biome on the left.",
  "noCatalog": "This pack has no biome catalog (biomes.json): floors cannot be generated.",
  "kind": {
    "pack": "pack biome · {{file}} · {{state}}",
    "packState_zero": "the pack's default",
    "packState_one": "{{count}} change from the default",
    "packState_other": "{{count}} changes from the default",
    "user": "user biome · {{state}}",
    "saved": "saved",
    "notSaved": "not saved yet"
  },
  "unsavedDot": "Unsaved changes",
  "migrated": "Older file format, converted on open: it is written in the new one when you save.",
  "newer": "{{id}} was made by a newer game (schema {{schema}}); this workshop reads up to {{max}}.",
  "confirmDiscard": "Discard the unsaved changes to '{{name}}'?",
  "mark": {
    "changed": "Changed from the pack's default",
    "reset": "Put {{name}} back to the pack's default"
  },
  "section": {
    "identity": "Identity",
    "layout": "Layout (size, rooms, corridors)",
    "difficulty": "Difficulty",
    "monsters": "Monsters",
    "hazards": "Floor hazards",
    "tide": "Tide (flooded floors)",
    "encounters": "Encounters",
    "mood": "Mood (light, torches, fog)",
    "instance": "Instance mode (one big dungeon on several levels)"
  },
  "identity": {
    "displayName": "Name",
    "description": "Description",
    "cardColor": "Card colour",
    "baseBiome": "Base biome",
    "baseBiomeTip": "Everything this biome does not change comes from this biome.",
    "lookFrom": "Look",
    "lookFromTip": "Whose kit (walls, props), lighting and fog it wears.",
    "look": "Look",
    "lookTip": "The art it is built with (kit, props, hazard models): set when the biome is created.",
    "sortOrder": "Order",
    "sortOrderTip": "Position in the Run Setup's biome list.",
    "inRunSetup": "Players can pick it in the Run Setup"
  },
  "layout": {
    "generator": "Generator",
    "generatorTip": "The level generator and all its settings.",
    "defaults": "Generator defaults",
    "defaultsTip": "The generator's own default settings.",
    "unknown": "Unknown generator: the base biome's layout is used.",
    "base": "The base biome's ({{type}})",
    "badJson": "{{name}}: not valid JSON."
  },
  "difficulty": {
    "secondLockFromDepth": { "label": "Second lock from floor", "tip": "From this floor the exit sits behind two locked doors." },
    "baseSpawnsPerRoom": { "label": "Monster spots per room", "tip": "Monster spots per room on the first floor." },
    "extraSpawnEveryDepths": { "label": "One more spot every", "tip": "One more monster spot per room every N floors." },
    "treasureChance": { "label": "Treasure chance", "tip": "Chance that a room holds treasure." },
    "potionChance": { "label": "Potion chance", "tip": "Chance that a room holds a potion." },
    "foodChance": { "label": "Food chance", "tip": "Chance that a room holds food." }
  },
  "monsters": {
    "hintPack": "Ticked monsters are this biome's.",
    "hintUser": "Ticked monsters replace the base biome's list; none ticked = the base biome's.",
    "roster": "Monsters (roster)",
    "rosterTip": "Regular monsters of the floors, picked by depth.",
    "fodder": "Hordes (fodder)",
    "fodderTip": "Crowd monsters of surges, ambushes and sleeper rooms.",
    "entry": "{{role}}, floor {{depth}}+",
    "inBase": "in base",
    "gone": "no longer in the game: untick to remove it",
    "guardian": "Guardian (mini-boss)",
    "guardianTip": "Guards the first key.",
    "none": "(none)",
    "guardianFromDepth": "Guardian from floor",
    "guardianFromDepthTip": "Floor from which the guardian appears.",
    "spawnerChance": "Spawner chance",
    "spawnerChanceTip": "Chance that a monster spot holds a spawner, on the first floor.",
    "spawnerChancePerDepth": "Spawners per floor",
    "spawnerChancePerDepthTip": "Extra spawner chance per deeper floor (-1: the base biome's)."
  },
  "hazards": {
    "on": "Hazards on",
    "rules": "Rules",
    "rulesTip": "Which hazards and how many per floor.",
    "add": "Add a hazard",
    "addNone": "Every known hazard is in the list",
    "remove": "Remove {{id}}",
    "customise": "Customise",
    "customiseTip": "Start from the base biome's hazards and change them.",
    "fromBase": "The base biome's hazards (Customise to change them).",
    "none": "No hazard rule.",
    "col": {
      "enabled": "On",
      "id": "Hazard",
      "placement": "Placement",
      "minDepth": "From floor",
      "baseCount": "Count",
      "perDepth": "+ per floor",
      "max": "Max",
      "blocksPath": "Blocks path",
      "friendly": "Friendly",
      "surface": "Surface"
    }
  },
  "tide": {
    "use": "Own tide (unticked: the base biome's)",
    "enabled": "The water rises and falls",
    "enabledLabel": "Tide",
    "enabledTip": "Off: the water stays at low tide all floor.",
    "firstLow": { "label": "First calm (s)", "tip": "Low water when the floor starts, before the first warning." },
    "lowHold": { "label": "Calm (s)", "tip": "Low water between two tides." },
    "warning": { "label": "Warning (s)", "tip": "The horn and the HUD hint before the water climbs." },
    "rise": { "label": "Rise (s)", "tip": "The water climbing: deep only once it ends." },
    "highHold": { "label": "High water (s)", "tip": "How long the water stays up." },
    "fall": { "label": "Fall (s)", "tip": "The water going back down." }
  },
  "encounters": {
    "label": "Surges, arenas, standoffs",
    "tip": "None ticked: the base biome's.",
    "entry": "{{type}}, {{trigger}}, floor {{depth}}+",
    "none": "The export lists no encounters."
  },
  "mood": {
    "use": "Own mood (unticked: the look's)",
    "group": { "light": "Light", "grade": "Colour grade", "torches": "Torches", "fog": "Fog of war" },
    "ambientSky": { "label": "Ambient from above", "tip": "Light on the ceiling side of everything." },
    "ambientEquator": { "label": "Ambient from the sides", "tip": "Light on walls and faces." },
    "ambientGround": { "label": "Ambient from below", "tip": "Light on undersides." },
    "moonColor": { "label": "Moon colour", "tip": "Colour of the dim directional light." },
    "moonIntensity": { "label": "Moon brightness", "tip": "Brightness of the directional light." },
    "desaturation": { "label": "Desaturation", "tip": "0 = painted colours, 1 = grey." },
    "darkening": { "label": "Darkening", "tip": "0.3 = stone 30% darker." },
    "tint": { "label": "Tint", "tip": "Colour the world is pulled toward." },
    "tintAmount": { "label": "Tint amount", "tip": "How much of the tint." },
    "rimLift": { "label": "Rim light", "tip": "Edge light that keeps silhouettes readable." },
    "heroFill": { "label": "Hero fill light", "tip": "Flat light on heroes on dark floors." },
    "torchChance": { "label": "How many torches", "tip": "Chance that a far room wall holds a torch. -1: the kit's own number." },
    "torchBoost": { "label": "Torch brightness", "tip": "Extra brightness: 0.35 = 35% brighter." },
    "torchRangeShrink": { "label": "Tighter torch light", "tip": "0.15 = 15% smaller pools of light." },
    "torchWarmth": { "label": "Torch warmth", "tip": "Pulls torch colour toward orange firelight." },
    "heroWarmth": { "label": "Hero light warmth", "tip": "Pulls the hero light toward firelight." },
    "heroGlow": { "label": "Glow under heroes", "tip": "Warm glow on the ground under each hero." },
    "fogUnseen": { "label": "Never seen", "tip": "Colour of areas nobody has seen." },
    "fogExploredTint": { "label": "Explored tint", "tip": "Tint of explored areas out of sight." },
    "fogExploredSaturation": { "label": "Explored colour", "tip": "How much colour remembered areas keep." },
    "visionScale": { "label": "Vision", "tip": "Heroes' sight radius multiplier: below 1 makes tunnels tense." },
    "fogEdgeSoftness": { "label": "Vision edge (m)", "tip": "Soft edge of the vision circle (-1: the look's)." }
  },
  "actions": {
    "save": "Save",
    "saveTip": "Ctrl+S. Pack biome: saves the changes (admin builds use them from their next floor). User biome: saves the whole file.",
    "resetAll": "Reset all",
    "resetAllTip": "Every value back to the pack's default.",
    "integrate": "Integrate into the game",
    "integrateTip": "Downloads the biome with its changes as its design file, for the pack's repository.",
    "saveAsUser": "Save as new user biome",
    "duplicate": "Duplicate",
    "toPack": "To pack…",
    "toPackTip": "Make this user biome a biome of the game (a new pack design file).",
    "delete": "Delete",
    "play": "Play in game",
    "playTip": "Rebuild the running game's floor with this biome (live link, Dungeon scene).",
    "playOff": "Connect the live link (Settings) to play it in a running game."
  },
  "dialog": {
    "newPack": "New pack biome",
    "newPackLead": "Starts from a pack biome (its look, values and monsters, with its changes) and downloads the new design file.",
    "newUser": "New user biome",
    "newUserLead": "Starts from a biome of the export: its layout, difficulty and monsters.",
    "toPack": "Make it a pack biome",
    "toPackLead": "Fills in what it leaves to its base biome and downloads the new design file.",
    "saveAsUser": "Save as a new user biome",
    "source": "Start from",
    "name": "Name",
    "key": "Key",
    "keyHint": "lower_snake_case: names the file and the biome asset (haunted_mine → BIO_HauntedMine).",
    "keyInvalid": "The key is lower_snake_case: letters, digits and _ (starting with a letter).",
    "keyTaken": "A biome '{{key}}' already exists.",
    "noBase": "Its base biome is not a biome of this pack's designs.",
    "create": "Create",
    "cancel": "Cancel",
    "copyOf": "Copy of {{name}}",
    "newOf": "New {{name}}",
    "myOf": "My {{name}}"
  },
  "done": {
    "savedPack": "Saved: admin builds use these changes from their next floor. 'Integrate into the game' makes them the pack's default.",
    "droppedPack": "Saved: no change left, the biome is the pack's default again.",
    "savedUser": "Saved '{{name}}'.",
    "deleted": "Deleted '{{name}}'.",
    "confirmDelete": "Delete the user biome '{{name}}'?",
    "deletePack": "A pack biome is part of the pack: delete its design file ({{file}}) and its BIO_ asset in Unity, then commit the pack.",
    "downloaded": "Downloaded {{file}}: commit it in the pack's repository as Data/Biomes/Design/{{file}}. Unity creates or updates the biome when it imports the file.",
    "integrated": "Downloaded {{file}} (the biome with its {{count}} change(s)): commit it in the pack's repository as Data/Biomes/Design/{{file}}. Once the game has it, 'Reset all' and save to drop the change.",
    "played": "Game: {{reply}}"
  },
  "preview": {
    "label": "Preview",
    "seed": "Seed",
    "dice": "Random seed",
    "run": "Run",
    "runTip": "The run's difficulty: how many floors it has (one seed for the whole run, as in the game).",
    "runOption": "{{name}} · {{count}} floors",
    "runDefault": "5 floors (older export: no difficulties)",
    "party": "Party",
    "partyTip": "Heroes in the party (bigger parties get wider corridors on some layouts).",
    "floor": "Floor {{depth}}",
    "final": "final",
    "finalTip": "The last floor: its stairs end the run (victory).",
    "card": "{{rooms}} rooms · {{spots}} spots · {{keys}} keys",
    "level": "level {{level}}",
    "map": "Map of floor {{depth}}",
    "generating": "Generating…",
    "failed": "Generation failed: {{error}}",
    "simLoading": "delve-sim is starting…",
    "simOff": "delve-sim is not available (see the status bar).",
    "info": "Floor {{depth}} of {{floors}} · {{width}}×{{height}} tiles · {{rooms}} rooms · {{spawns}} monster spots · {{spawners}} spawners · {{keys}} keys · {{hazards}} hazards · level {{level}} · {{ms}} ms",
    "fingerprint": "Fingerprint {{fingerprint}}",
    "hover": "Tile ({{x}}, {{y}}): {{tile}}",
    "hoverRoom": "Tile ({{x}}, {{y}}): {{tile}}, room {{room}}",
    "hoverRoomTags": "Tile ({{x}}, {{y}}): {{tile}}, room {{room}} ({{tags}})",
    "playable": "This floor is playable",
    "issues": "Issues",
    "noFloor": "No floor yet"
  },
  "tile": { "rock": "rock", "room": "room", "corridor": "corridor", "water": "water", "chasm": "chasm" },
  "legend": {
    "label": "Legend",
    "start": "Start", "exit": "Exit", "spawn": "Monster spot", "spawner": "Spawner", "treasure": "Treasure",
    "potion": "Potion", "food": "Food", "key": "Key", "door": "Door", "lockedDoor": "Locked door", "hazard": "Hazard",
    "room": "Room", "corridor": "Corridor", "water": "Water", "chasm": "Chasm",
    "stairsDown": "Stairs down", "stairsUp": "Stairs up", "map": "Map", "compass": "Compass", "bossKey": "Boss key", "bossDoor": "Boss door"
  },
  "view": {
    "label": "Preview",
    "run": "Run (floor by floor)",
    "runTip": "The Dungeon mode run: one floor per depth, as the game builds it.",
    "instance": "Instance",
    "instanceTip": "The Instance mode dungeon: every level, its stairs, maps, compass, keys and the boss door."
  },
  "instance": {
    "label": "Instance preview",
    "oldSim": "This delve-sim predates Instance mode (protocol 2): rebuild it (make sim).",
    "level": "Level {{level}}",
    "boss": "boss",
    "map": "Map of level {{level}}",
    "card": "{{rooms}} rooms · {{keys}} keys · {{items}} items",
    "info": "{{levels}} levels · {{width}}×{{height}} tiles · {{keys}} small keys · {{trips}} stair trips to solve · {{changes}} level changes in the playthrough · {{ms}} ms",
    "mission": "Mission (playing order)",
    "step": { "key": "Key {{lock}}", "bosskey": "Boss key", "map": "Map", "compass": "Compass", "boss": "Boss" },
    "where": "level {{level}}, room {{room}}",
    "behind": "behind lock {{lock}}",
    "playable": "This instance is playable: the boss can be reached key by key.",
    "validate": "Validate {{seeds}} instances",
    "validateOk": "✔ {{count}} instances playable (avg {{avg}} ms, max {{max}} ms) · {{rooms}} rooms per level · {{trips}} stair trips on average",
    "validateBad": "✖ {{failed}}/{{count}} instances fail — e.g. seed {{seed}}: {{issue}}",
    "formHint": "How this biome's Instance mode dungeon is built: levels, their size and rooms, the small keys on the way to the boss key. See the Instance view of the preview."
  },
  "validate": {
    "run": "Validate {{seeds}} seeds × {{depths}} floors",
    "cancel": "Cancel",
    "running": "Validating…",
    "cancelled": "Validation cancelled.",
    "ok": "✔ {{floors}} floors playable (avg {{avg}} ms, max {{max}} ms)",
    "bad": "✖ {{failed}}/{{floors}} floors fail — e.g. seed {{seed}} floor {{depth}}: {{issue}}",
    "failed": "Validation failed: {{error}}"
  },
  "curve": {
    "title": "Difficulty by floor",
    "floor": "Floor",
    "level": "Level",
    "locks": "Locks",
    "spots": "Spots/room",
    "treasure": "Treasure",
    "potion": "Potion",
    "food": "Food"
  },
  "check": {
    "baseMissing": "Base biome '{{id}}' is missing: the first built-in biome is used.",
    "lookMissing": "Look '{{id}}' is missing: the base biome's look is used.",
    "layoutUnknown": "Layout type '{{type}}' is unknown: the base biome's layout is used.",
    "monsterUnknown": "Unknown monster '{{id}}' (ignored).",
    "hazardUnknown": "Unknown hazard '{{id}}': no biome has it, so nothing is placed.",
    "noMonsters": "No monsters: add at least one to the roster."
  }
}
